export default "__VITE_ASSET__CDLCqvwi__"